/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import classNames from "classnames";
import { Stack, Heading, Text } from "components";
import { FC, ReactNode } from "react";

type Props = {
  children: ReactNode;
  title: string;
  note?: string;
  className?: string;
};

const FormSection: FC<Props> = ({ children, title, note, className }) => {
  return (
    <Stack component="section" className={classNames("gap-y-10", className)}>
      <Stack className="gap-y-1">
        <Heading
          as="h2"
          className={classNames("text-xl -text--theme-colors-text-title-brand")}
        >
          {title}
        </Heading>
        {note && <Text className="-text--theme-colors-text-body">{note}</Text>}
      </Stack>
      <Stack className="gap-y-8 sm:gap-y-10">{children}</Stack>
    </Stack>
  );
};

export default FormSection;
